import { Button, Stack } from '@mui/material';

import { closeDialog, openDialog } from '@/components/Dialog';
import openConfirmDialog from '@/components/openConfirmDialog';
import {
  IMaintenance,
  IMaintenanceStatus,
} from '@/interfaces/maintenance/IMaintenance';
import maintenancesService from '@/services/maintenances';

import MaintenanceNotesForm from '../MaintenanceNotesForm';
import MaintenanceStateForm from '../MaintenanceStateForm';

interface Props {
  maintenance: IMaintenance;
  onUpdate: (updatedMaintenance: IMaintenance) => void;
}

export default function MaintenanceActions({ maintenance, onUpdate }: Props) {
  const { id, status, startDate: startedAt } = maintenance;

  const openNotesDialog = () => {
    openDialog({
      title: 'Edit notes',
      content: (
        <MaintenanceNotesForm maintenance={maintenance} onUpdate={onUpdate} />
      ),
    });
  };
  const openStateDialog = (isFinish?: boolean) => {
    openDialog({
      title: !isFinish ? 'Start maintenance' : 'Finish maintenance',
      content: (
        <MaintenanceStateForm
          maintenanceId={id}
          isFinish={isFinish}
          startedAt={startedAt}
          onUpdate={onUpdate}
        />
      ),
    });
  };

  const openCancelDialog = () => {
    openConfirmDialog({
      title: 'Cancel maintenance',
      onConfirm: async () => {
        const updatedMaintenance = await maintenancesService.cancelMaintenance(
          id
        );

        onUpdate(updatedMaintenance);
        closeDialog();
      },
    });
  };

  return (
    <Stack
      direction="row"
      flex={1}
      gap={1}
      justifyContent="flex-end"
      flexWrap="wrap"
    >
      {status === IMaintenanceStatus.PENDING && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => openStateDialog()}
        >
          Start maintenance
        </Button>
      )}

      {status === IMaintenanceStatus.ACTIVE && (
        <Button
          color="primary"
          variant="contained"
          onClick={() => openStateDialog(true)}
        >
          Finish maintenance
        </Button>
      )}

      {status !== IMaintenanceStatus.CANCELED && (
        <Button color="primary" variant="outlined" onClick={openNotesDialog}>
          Edit notes
        </Button>
      )}

      {status === IMaintenanceStatus.PENDING && (
        <Button color="error" variant="contained" onClick={openCancelDialog}>
          Cancel maintenance
        </Button>
      )}
    </Stack>
  );
}
